import React, { useContext, useEffect, useState } from "react";
import ArrowPolygon from "../../Icons/ArrowPolygon";
import MachineDataContext from "../../themeContext/MachineDataContext";
import { DataObject, MachinesByGroup } from "../../Types/dashboardTypes";

interface Props {
  isShowTitle?: boolean;
  selectedMachine?: MachinesByGroup;
  visibleData?: DataObject;
}

const Properties: React.FC<Props> = (props) => {
  const { selectedMachine, visibleData, isShowTitle = true } = props;
  const [currentData, setCurrentData] = useState<DataObject>();
  const data = useContext(MachineDataContext);

  useEffect(() => {
    if (visibleData) {
      setCurrentData(visibleData);
    } else {
      // re-org data for ease of use, based on serial number of selected machine
      if (selectedMachine != undefined) {
        setCurrentData(data[selectedMachine.machineSerial] as DataObject);
      } else {
        setCurrentData({
          oeeTimeDown: null,
          oeeUnitsBad: null,
          oeeUnitsGood: null,
          oeeUnitsTotal: null,
          oeeTimeIdealCycle: null,
          oeeTimeOperating: null,
        });
      }
    }
  }, [data, selectedMachine]);

  return (
    <div className="properties-component">
      {isShowTitle && <div className="properties-title">Properties</div>}
      <div className="properties-text">
        <div className="flex space-between">
          <div className="properties-status">Parts:</div>
          <div className="properties-values">
            <span style={{ color: "var(--green-1)" }}>
              {currentData?.oeeUnitsGood ? currentData?.oeeUnitsGood : "NA"}
            </span>
            <span> | </span>
            <span style={{ color: "var(--red-1)" }}>{currentData?.oeeUnitsBad ? currentData?.oeeUnitsBad : "NA"}</span>
            <span> | </span>
            <span>{currentData?.oeeUnitsTotal ? currentData?.oeeUnitsTotal : "NA"}</span>
          </div>
        </div>
        <div className="flex space-between">
          <div>Time:</div>
          <div className="properties-values">
            <span>{currentData?.oeeTimeOperating ? currentData?.oeeTimeOperating : "NA"}</span>
            <span className="arrow-polygon-green">
              <ArrowPolygon height="16px" width="16px" color="var(--green-1)" />
            </span>
            <span>{currentData?.oeeTimeDown ? currentData?.oeeTimeDown : "NA"}</span>
            <span className="arrow-polygon-red">
              <ArrowPolygon height="16px" width="16px" color="var(--red-1)" className="rotate-180" />
            </span>
          </div>
        </div>
        <div className="flex space-between">
          <div>Ideal Cycle:</div>
          <div className="properties-values">
            {currentData?.oeeTimeIdealCycle ? currentData?.oeeTimeIdealCycle : "NA"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Properties;
